import React from "react";
class Paginator extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    };

    this.change_page = this.change_page.bind(this);

  }

  componentDidMount(){
    this.notify_if_page_out_of_range(this.props);
  }

  componentDidUpdate(prevProps){
    if (
      prevProps.results !== this.props.results ||
      prevProps.per_page !== this.props.per_page ||
      prevProps.page !== this.props.page
    ) {
      this.notify_if_page_out_of_range(this.props);
    }
  }

  numeric_prop(name, fallback=0){
    const value = Number(this.props[name]);
    return Number.isFinite(value) ? value : fallback;
  }

  results(){
    return Math.max(0, this.numeric_prop('results'));
  }

  per_page(){
    return Math.max(1, this.numeric_prop('per_page', 1));
  }

  total_pages(){
    return Math.max(1, Math.ceil(this.results() / this.per_page()));
  }

  current_page(){
    return this.clamp_page(this.numeric_prop('page'));
  }

  clamp_page(page){
    return Math.min(Math.max(0, page), this.total_pages() - 1);
  }

  notify_if_page_out_of_range(props){
    const page = Number(props.page);
    const perPage = Math.max(1, Number(props.per_page) || 1);
    const results = Math.max(0, Number(props.results) || 0);
    const totalPages = Math.max(1, Math.ceil(results / perPage));

    if (!Number.isFinite(page)) {
      this.change_page(0);
      return;
    }

    const clampedPage = Math.min(Math.max(0, page), totalPages - 1);
    if (clampedPage !== page) {
      if (this.props.on_page_change) {
        this.props.on_page_change(clampedPage);
      }
    }
  }

  change_page(page){
    const nextPage = this.clamp_page(page);

    if (nextPage === this.current_page()) {
      return;
    }

    if (this.props.on_page_change) {
      this.props.on_page_change(nextPage);
    }
  }

  page_numbers(){
    const totalPages = this.total_pages();
    const currentPage = this.current_page();

    if (totalPages <= 7) {
      return Array.from({length: totalPages}, (_, index) => index);
    }

    const pages = [0];
    const start = Math.max(1, currentPage - 1);
    const end = Math.min(totalPages - 2, currentPage + 1);

    if (start > 1) {
      pages.push('start-gap');
    }

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (end < totalPages - 2) {
      pages.push('end-gap');
    }

    pages.push(totalPages - 1);
    return pages;
  }

  result_range_text(){
    const results = this.results();

    if (results === 0) {
      return 'No results';
    }

    const start = this.current_page() * this.per_page() + 1;
    const end = Math.min(results, start + this.per_page() - 1);
    return `${start}-${end} of ${results}`;
  }

  render () {
    const currentPage = this.current_page();
    const totalPages = this.total_pages();

    return (
        <div className="psintegril-paginator">
          <div className="psintegril-paginator-summary">
            <span>{this.result_range_text()}</span>
            <span>Page {currentPage + 1} of {totalPages}</span>
          </div>

          <div className="psintegril-paginator-controls" aria-label="Pagination">
            <button
              className="psintegril-paginator-button"
              type="button"
              disabled={currentPage === 0}
              onClick={() => this.change_page(currentPage - 1)}
            >
              Previous
            </button>

            {this.page_numbers().map((page) => (
              typeof page === 'number' ? (
                <button
                  className={`psintegril-paginator-button ${page === currentPage ? 'psintegril-paginator-button-active' : ''}`}
                  type="button"
                  key={page}
                  aria-current={page === currentPage ? 'page' : undefined}
                  onClick={() => this.change_page(page)}
                >
                  {page + 1}
                </button>
              ) : (
                <span className="psintegril-paginator-gap" key={page}>...</span>
              )
            ))}

            <button
              className="psintegril-paginator-button"
              type="button"
              disabled={currentPage >= totalPages - 1}
              onClick={() => this.change_page(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>
    );
  }
}

export default Paginator;
